export default __webpack_public_path__ + "static/media/job_offer4_l.7458d600.jpg";